import React from 'react';
import { Box, keyframes, useTheme } from '@mui/material';

interface ConfettiProps {
  show?: boolean;
}

// Simple falling animation
const confettiFall = keyframes`
  0% {
    transform: translateY(-20px) rotate(0deg);
    opacity: 1;
  }
  100% {
    transform: translateY(500px) rotate(720deg);
    opacity: 0;
  }
`;

const confettiFallLeft = keyframes`
  0% {
    transform: translateY(-20px) translateX(0px) rotate(0deg);
    opacity: 1;
  }
  100% {
    transform: translateY(500px) translateX(-100px) rotate(720deg);
    opacity: 0;
  }
`;

const confettiFallRight = keyframes`
  0% {
    transform: translateY(-20px) translateX(0px) rotate(0deg);
    opacity: 1;
  }
  100% {
    transform: translateY(500px) translateX(100px) rotate(720deg);
    opacity: 0;
  }
`;

const Confetti: React.FC<ConfettiProps> = ({ show = false }) => {
  const theme = useTheme();

  if (!show) return null;

  const colors = Object.values(theme.palette).flatMap((color) =>
    typeof color === 'object' && color.main
      ? [color.main, color.light, color.dark]
      : [],
  );

  const animations = [confettiFall, confettiFallLeft, confettiFallRight];

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 100,
        right: 50,
        width: 350,
        height: 400,
        pointerEvents: 'none',
        zIndex: 10001,
        overflow: 'visible',
      }}
    >
      {Array.from({ length: 15 }).map((_, i) => {
        const size = 6 + Math.random() * 6;
        const color = colors[Math.floor(Math.random() * colors.length)];
        const animationDuration = 2 + Math.random();
        const delay = Math.random() * 0.5;
        const animationType =
          animations[Math.floor(Math.random() * animations.length)];

        return (
          <Box
            key={i}
            sx={{
              position: 'absolute',
              left: `${Math.random() * 100}%`,
              top: 0,
              width: size,
              height: size,
              backgroundColor: color,
              borderRadius: Math.random() > 0.5 ? '50%' : '2px',
              animation: `${animationType} ${animationDuration}s linear ${delay}s forwards`,
            }}
          />
        );
      })}
    </Box>
  );
};

export default Confetti;
